/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Placeholder_1Inputs */

const en_try_magic_placeholder_1 = /** @type {(inputs: Try_Magic_Placeholder_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type something...`)
};

const es_try_magic_placeholder_1 = /** @type {(inputs: Try_Magic_Placeholder_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe algo...`)
};

/**
* | output |
* | --- |
* | "Type something..." |
*
* @param {Try_Magic_Placeholder_1Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_placeholder_1 = /** @type {((inputs?: Try_Magic_Placeholder_1Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Placeholder_1Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_placeholder_1(inputs)
	return en_try_magic_placeholder_1(inputs)
});